import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { fromJS } from 'immutable';
import { useCallback, useMemo, useState } from 'react';
import { isJourneyReport } from 'reporting-data/tsTypes/reportTypes';
import { isSucceeded } from 'reporting-data/asyncData/AsyncData';
// @ts-expect-error Untyped dependency
import DateRangePicker from 'reporting-ui-components/components/shared/DateRangePicker';
import { MIN_DATE_RANGE_DAYS } from 'reporting-ui-components/constants/journeyDateRangeConstants';
import { dateIsOutsideBounds, getDateRangeBounds, getDateRangeFromEventDateInterval, getEventDateItervalFromDateRange, getJourneyRangeTypeOverrides, getRollingDaysOptions, getSimpleDatesfromDateRange } from 'reporting-ui-components/lib/journey/journeyDateRangeUtils';
import { useFetchMaxDays } from './fetchMaxDays';
// @ts-expect-error Untyped dependency
import DateRangeLabel from 'reporting-ui-components/components/shared/DateRangeLabel';
import BasePopoverEditorComponent from '../common/BasePopoverEditorComponent';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const JourneyDateRangePicker = ({
  report,
  onChange,
  isV2FilterExperience
}) => {
  const journeyReport = useMemo(() => report.toJS(), [report]);
  const eventDateInterval = journeyReport.journeyQuery.eventDateInterval;
  const dateRangeFromReport = getDateRangeFromEventDateInterval(eventDateInterval);
  const simpleDateRangeValue = getSimpleDatesfromDateRange(dateRangeFromReport);
  const [customDateValue, setCustomDateValue] = useState(simpleDateRangeValue);
  const asyncMaxDays = useFetchMaxDays(journeyReport.journeyQuery);
  const maxDays = isSucceeded(asyncMaxDays) ? asyncMaxDays.data : MIN_DATE_RANGE_DAYS;
  const {
    min,
    max
  } = getDateRangeBounds(maxDays, customDateValue);
  const isDateOutOfBounds = maxDays > 0 && dateIsOutsideBounds(maxDays, customDateValue);
  const onDateRangeUpdate = useCallback(dateRange => {
    const newInterval = getEventDateItervalFromDateRange(dateRange);
    const newSimpleDate = getSimpleDatesfromDateRange(dateRange);
    if (!dateIsOutsideBounds(maxDays, newSimpleDate)) {
      const updatedReport = report.setIn(['journeyQuery', 'eventDateInterval'], fromJS(newInterval));
      onChange(updatedReport);
    }
    setCustomDateValue(newSimpleDate);
  }, [maxDays, onChange, report]);
  const outOfBoundsMsg = isDateOutOfBounds ? I18n.text('settingLabels.dateRange.journey.maxDaysMessage', {
    maxDays
  }) : undefined;
  const dateRangeInput = /*#__PURE__*/_jsx(DateRangePicker, Object.assign({
    "data-test-id": "journey-date-picker",
    buttonUse: "form",
    condensed: true,
    hideEntireCurrentUnit: true,
    onChange: onDateRangeUpdate,
    rangeTypeOverrides: getJourneyRangeTypeOverrides(maxDays),
    rollingDateOverrides: getRollingDaysOptions(maxDays)
  }, dateRangeFromReport, {
    format: "YYYYMMDD",
    maxCustomValue: max,
    minCustomValue: min,
    outOfBoundsMessage: outOfBoundsMsg
  }));
  if (isV2FilterExperience) {
    const buttonContent = /*#__PURE__*/_jsx(DateRangeLabel, {
      dateRange: fromJS(dateRangeFromReport)
    });
    const toolTipContent = () => {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingLabels.dateRange.label"
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
          children: buttonContent
        })]
      });
    };
    const popoverBody = /*#__PURE__*/_jsx(View, {
      paddingBlockEnd: "500",
      inlineSize: "300px",
      children: dateRangeInput
    });
    return /*#__PURE__*/_jsx(BasePopoverEditorComponent, {
      buttonContent: buttonContent,
      dataTestId: "open-date-range-filter-button",
      hasSelectedValue: true,
      tooltipContent: toolTipContent(),
      popoverBody: popoverBody
    });
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingLabels.dateRange.label"
    }),
    children: dateRangeInput
  });
};
JourneyDateRangePicker.isDateEditor = true;
JourneyDateRangePicker.isFilterEditor = true;
JourneyDateRangePicker.isUsableForReport = report => {
  return isJourneyReport(report);
};
export default JourneyDateRangePicker;